var searchThemeWeb = {
  closeIconColor: 'text'
};

export { searchThemeWeb };
